// extracted by mini-css-extract-plugin
module.exports = {"center":"TextAlign_center__oSmar","justify":"TextAlign_justify__2Xm_X","left":"TextAlign_left__2c4yN","right":"TextAlign_right__1TrHZ"};